const FILE_TYPES_IMAGE = '.jpg,.gif,.png,.jpeg,.svg,.webp'
const FILE_TYPES_DOCS =
  '.doc,.docx,.ppt,.pptx,.txt,.pdf,.xls,.xlsx,.csv,.ods,.odt,.rtf'

const UNKNOWN_FILE_MIME_TYPE = 'application/octet-stream'

const ALL_FILE_TYPES = `${FILE_TYPES_IMAGE},${FILE_TYPES_DOCS}`

const IMAGE_FILE_MIMES_TYPES = [
  'image/jpeg',
  'image/gif',
  'image/png',
  'image/svg+xml',
  'image/webp',
]

const DOCUMENT_FILE_MIMES_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',
  'application/rtf',
]

const ALL_FILE_MIMES_TYPES = [
  ...IMAGE_FILE_MIMES_TYPES,
  ...DOCUMENT_FILE_MIMES_TYPES,
]

const BYTES_UNIT = 'bytes'
const KILOBYTE_UNIT = 'kB'
const MEGABYTE_UNIT = 'MB'
const GIGABYTE_UNIT = 'GB'

const BYTE_UNIT_EXPONENT = {
  [BYTES_UNIT]: 2 ** 0,
  [KILOBYTE_UNIT]: 2 ** 10,
  [MEGABYTE_UNIT]: 2 ** 20,
  [GIGABYTE_UNIT]: 2 ** 30,
}

const DEFAULT_FILE_SIZE_LIMIT = 10
const MAX_FILE_SIZE =
  DEFAULT_FILE_SIZE_LIMIT * BYTE_UNIT_EXPONENT[MEGABYTE_UNIT]

// Caso for utilizar algum parâmetro de arquivo que não exista na lista, favor inclua para validação!
const MIME_TYP_VALIDATION = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  webp: 'image/webp',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  odt: 'application/vnd.oasis.opendocument.text',
  rtf: 'application/rtf',
}

const OPENABLE_FILE_MIME_TYPES = [
  'image/jpeg',
  'image/gif',
  'image/png',
  'image/svg+xml',
  'image/webp',
  'application/pdf',
]
const OPENABLE_FILE_TYPES = ['jpg', 'jpeg', 'gif', 'png', 'svg', 'webp', 'pdf']

const PDF_FILE_TYPE = '.pdf'
const PDF_FILE_MIMES_TYPES = ['application/pdf']

// Atalhos de tipo/mimeType prontos para o método customizado do yup `fileUpload({ fileGroup: '...' })`
const FILE_GROUPS = {
  all: { types: ALL_FILE_TYPES, mimeTypes: ALL_FILE_MIMES_TYPES },
  pdfOnly: { types: PDF_FILE_TYPE, mimeTypes: PDF_FILE_MIMES_TYPES },
  document: { types: FILE_TYPES_DOCS, mimeTypes: DOCUMENT_FILE_MIMES_TYPES },
  image: { types: FILE_TYPES_IMAGE, mimeTypes: IMAGE_FILE_MIMES_TYPES },
}

// Discriminador usado no registro de métodos customizados do yup (configs/yup)
const STRING_SCHEMA_TYPE = 'string'
const DATE_SCHEMA_TYPE = 'date'
const MIXED_SCHEMA_TYPE = 'mixed'

// Usado pelo método customizado do yup `domain()`
const DOMAIN_REGEX = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

// Usado pelo método customizado do yup `alphanumeric()`
const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]+$/

// Usado pelo método customizado do yup `strongPassword()`
const STRONG_PASSWORD_REGEX =
  // eslint-disable-next-line no-useless-escape
  /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ `!*@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]).{8,}$/

const validations = {
  ALL_FILE_MIMES_TYPES,
  ALL_FILE_TYPES,
  ALPHANUMERIC_REGEX,
  BYTE_UNIT_EXPONENT,
  DATE_SCHEMA_TYPE,
  DOCUMENT_FILE_MIMES_TYPES,
  DOMAIN_REGEX,
  FILE_GROUPS,
  FILE_TYPES_DOCS,
  FILE_TYPES_IMAGE,
  IMAGE_FILE_MIMES_TYPES,
  MAX_FILE_SIZE,
  MIME_TYP_VALIDATION,
  MIXED_SCHEMA_TYPE,
  OPENABLE_FILE_MIME_TYPES,
  OPENABLE_FILE_TYPES,
  PDF_FILE_MIMES_TYPES,
  PDF_FILE_TYPE,
  STRING_SCHEMA_TYPE,
  STRONG_PASSWORD_REGEX,
  UNKNOWN_FILE_MIME_TYPE,
}

export default validations
